module.exports = __webpack_public_path__ + "static/5-0e8f59e123c54538899ff871fd9eb24f.jpg";